// Helper functions for locale parsing

export function getLanguageFromLocale(
  locale: string | null | undefined,
): string {
  if (!locale) return "en";
  return locale.split("_")[0] ?? "en";
}

export function getCountryFromLocale(
  locale: string | null | undefined,
): string {
  if (!locale) return "US";
  return locale.split("_")[1] ?? "US";
}
